module.exports = __webpack_public_path__ + "static/objective-9558511dbe896aed866e70cdf2c20aaf.png";